import Vue from 'vue'
import Router from 'vue-router'
import AppInfo from '@/components/AppInfo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/vue-project/',
  routes: [
    {
      path: '/',
      name: 'AppInfo',
      component: AppInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js